var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 119.000004846969;
var w = 466;
var h = 466;
var nm = "BTC noout";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Fill 2",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.667
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.333
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            100
                        ]
                    },
                    {
                        t: 15.0000006109625,
                        s: [
                            0
                        ],
                        h: 1
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    2500,
                    2500,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                127.025
                            ]
                        ],
                        o: [
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                127.025
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ]
                        ],
                        v: [
                            [
                                2500,
                                2270
                            ],
                            [
                                2270,
                                2500
                            ],
                            [
                                2500,
                                2730
                            ],
                            [
                                2730,
                                2500
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                ty: "gr",
                                it: [
                                    {
                                        ty: "gr",
                                        it: [
                                            {
                                                ty: "gr",
                                                it: [
                                                    {
                                                        ty: "gr",
                                                        it: [
                                                            {
                                                                ind: 0,
                                                                ty: "sh",
                                                                ix: 1,
                                                                ks: {
                                                                    a: 0,
                                                                    k: {
                                                                        i: [
                                                                            [
                                                                                -127.025,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -127.025
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                127.026,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                127.026
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ]
                                                                        ],
                                                                        o: [
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                127.026,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                127.026
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                -127.025,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -127.025
                                                                            ]
                                                                        ],
                                                                        v: [
                                                                            [
                                                                                0,
                                                                                -230
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -230
                                                                            ],
                                                                            [
                                                                                230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                230
                                                                            ],
                                                                            [
                                                                                0,
                                                                                230
                                                                            ],
                                                                            [
                                                                                -230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                -230,
                                                                                0
                                                                            ]
                                                                        ],
                                                                        c: true
                                                                    },
                                                                    ix: 2
                                                                },
                                                                nm: "Path 1",
                                                                mn: "ADBE Vector Shape - Group",
                                                                hd: false
                                                            },
                                                            {
                                                                ty: "fl",
                                                                c: {
                                                                    a: 0,
                                                                    k: [
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    ],
                                                                    ix: 4
                                                                },
                                                                o: {
                                                                    a: 0,
                                                                    k: 100,
                                                                    ix: 5
                                                                },
                                                                r: 1,
                                                                bm: 0,
                                                                nm: "Fill 1",
                                                                mn: "ADBE Vector Graphic - Fill",
                                                                hd: false
                                                            },
                                                            {
                                                                ty: "tr",
                                                                p: {
                                                                    a: 0,
                                                                    k: [
                                                                        0,
                                                                        0
                                                                    ],
                                                                    ix: 2
                                                                },
                                                                a: {
                                                                    a: 0,
                                                                    k: [
                                                                        0,
                                                                        0
                                                                    ],
                                                                    ix: 1
                                                                },
                                                                s: {
                                                                    a: 0,
                                                                    k: [
                                                                        100,
                                                                        100
                                                                    ],
                                                                    ix: 3
                                                                },
                                                                r: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 6
                                                                },
                                                                o: {
                                                                    a: 0,
                                                                    k: 100,
                                                                    ix: 7
                                                                },
                                                                sk: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 4
                                                                },
                                                                sa: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 5
                                                                },
                                                                nm: "Transform"
                                                            }
                                                        ],
                                                        nm: "Rectangle",
                                                        np: 2,
                                                        cix: 2,
                                                        bm: 0,
                                                        ix: 1,
                                                        mn: "ADBE Vector Group",
                                                        hd: false
                                                    },
                                                    {
                                                        ty: "tr",
                                                        p: {
                                                            a: 0,
                                                            k: [
                                                                500,
                                                                500
                                                            ],
                                                            ix: 2
                                                        },
                                                        a: {
                                                            a: 0,
                                                            k: [
                                                                0,
                                                                0
                                                            ],
                                                            ix: 1
                                                        },
                                                        s: {
                                                            a: 0,
                                                            k: [
                                                                100,
                                                                100
                                                            ],
                                                            ix: 3
                                                        },
                                                        r: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 6
                                                        },
                                                        o: {
                                                            a: 0,
                                                            k: 100,
                                                            ix: 7
                                                        },
                                                        sk: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 4
                                                        },
                                                        sa: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 5
                                                        },
                                                        nm: "Transform"
                                                    }
                                                ],
                                                nm: "icon/2tone/bank",
                                                np: 1,
                                                cix: 2,
                                                bm: 0,
                                                ix: 1,
                                                mn: "ADBE Vector Group",
                                                hd: false
                                            },
                                            {
                                                ty: "tr",
                                                p: {
                                                    a: 0,
                                                    k: [
                                                        500,
                                                        500
                                                    ],
                                                    ix: 2
                                                },
                                                a: {
                                                    a: 0,
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    ix: 1
                                                },
                                                s: {
                                                    a: 0,
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    ix: 3
                                                },
                                                r: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 6
                                                },
                                                o: {
                                                    a: 0,
                                                    k: 100,
                                                    ix: 7
                                                },
                                                sk: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 4
                                                },
                                                sa: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 5
                                                },
                                                nm: "Transform"
                                            }
                                        ],
                                        nm: "Group",
                                        np: 1,
                                        cix: 2,
                                        bm: 0,
                                        ix: 1,
                                        mn: "ADBE Vector Group",
                                        hd: false
                                    },
                                    {
                                        ty: "tr",
                                        p: {
                                            a: 0,
                                            k: [
                                                500,
                                                500
                                            ],
                                            ix: 2
                                        },
                                        a: {
                                            a: 0,
                                            k: [
                                                0,
                                                0
                                            ],
                                            ix: 1
                                        },
                                        s: {
                                            a: 0,
                                            k: [
                                                100,
                                                100
                                            ],
                                            ix: 3
                                        },
                                        r: {
                                            a: 0,
                                            k: 0,
                                            ix: 6
                                        },
                                        o: {
                                            a: 0,
                                            k: 100,
                                            ix: 7
                                        },
                                        sk: {
                                            a: 0,
                                            k: 0,
                                            ix: 4
                                        },
                                        sa: {
                                            a: 0,
                                            k: 0,
                                            ix: 5
                                        },
                                        nm: "Transform"
                                    }
                                ],
                                nm: "icon/2tone/bank",
                                np: 1,
                                cix: 2,
                                bm: 0,
                                ix: 1,
                                mn: "ADBE Vector Group",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        500,
                                        500
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "lending-platforms",
                        np: 1,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "usecase-accept1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Btop 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    238.675,
                    195.481,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        21.03
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        21.03,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        21.03,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -21.03
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -52.752,
                                        38.387
                                    ],
                                    [
                                        14.674,
                                        38.387
                                    ],
                                    [
                                        52.752,
                                        0.31
                                    ],
                                    [
                                        52.752,
                                        -0.31
                                    ],
                                    [
                                        14.674,
                                        -38.387
                                    ],
                                    [
                                        -52.752,
                                        -38.387
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 13,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 0,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Bbottom 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    238.675,
                    272.256,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -21.03
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        21.03,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        21.03,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        21.03
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -52.752,
                                        -38.387
                                    ],
                                    [
                                        14.674,
                                        -38.387
                                    ],
                                    [
                                        52.752,
                                        -0.31
                                    ],
                                    [
                                        52.752,
                                        0.31
                                    ],
                                    [
                                        14.674,
                                        38.387
                                    ],
                                    [
                                        -52.752,
                                        38.387
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 13,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 0,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Stroked 5",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    253.18,
                    141.808,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -13.594
                                    ],
                                    [
                                        0,
                                        13.594
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 22,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "Stroked 4",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    214.803,
                    141.808,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -13.594
                                    ],
                                    [
                                        0,
                                        13.594
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 22,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: "Stroked 7",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    253.18,
                    326.146,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -13.594
                                    ],
                                    [
                                        0,
                                        13.594
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 22,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: "Stroked 6",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    214.803,
                    326.146,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -13.594
                                    ],
                                    [
                                        0,
                                        13.594
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 22,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 11,
        ty: 4,
        nm: "Stroked",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    500,
                    500,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                d: 1,
                                ty: "el",
                                s: {
                                    a: 0,
                                    k: [
                                        460,
                                        460
                                    ],
                                    ix: 2
                                },
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 3
                                },
                                nm: "Ellipse Path 1",
                                mn: "ADBE Vector Shape - Ellipse",
                                hd: false
                            },
                            {
                                ty: "fl",
                                c: {
                                    a: 0,
                                    k: [
                                        1,
                                        0.96862745285,
                                        0.917647063732,
                                        1
                                    ],
                                    ix: 4,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 5
                                },
                                r: 1,
                                bm: 0,
                                nm: "Fill 1",
                                mn: "ADBE Vector Graphic - Fill",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Oval",
                        np: 2,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "icon/gummie/btc",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var BTC = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, BTC as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=BTC.json.es.js.map
